import { thousandSeparator } from './formatters'
import { startCase, camelCase } from 'lodash'
import { translate } from '../services/translate'

export const formatPrice1 = (value, type) => {
  if (type === 'CREDIT_CARDS') {
    return `$${thousandSeparator(value)}`
  }
  return `${(value / 100).toFixed(2)}%`
}

export const formatPrice2 = (value, type) => {
  switch (type) {
    case 'HOME_LOANS': {
      return `${(value / 100).toFixed(2)}%`
    }
    case 'BUSINESS_LOANS': {
      return value === 0 ? 'Medium' : value < 0 ? 'Loose' : 'Tight'
    }
    case 'DEPOSITS':
    case 'INSTITUTIONAL_BANKING': {
      return value
    }
    case 'CREDIT_CARDS': {
      return (value / 100).toFixed(2)
    }
    case 'WEALTH_MANAGEMENT': {
      return value === 0 ? 'Medium' : value < 0 ? 'Low' : 'High'
    }
    case 'OFFSHORE_BANK': {
      return `$${thousandSeparator(value)}`
    }
  }
}

/**
 * Map names to vanities
 */
export const mapNames = (type) => {
  switch (camelCase(type)) {
    case 'homeLoans':
      return translate('peerInsights.screen2.homeLoans', 'Mortgages')
    case 'businessLoans':
      return translate('peerInsights.screen2.businessLoans', 'Business Lending')
    case 'deposits':
      return translate('peerInsights.screen2.deposits', 'Deposits')
    case 'creditCards':
      return translate('peerInsights.screen2.creditCards', 'Credit Cards')
    case 'branches':
      return translate('peerInsights.screen2.branches', 'Points of Presence')
    case 'balances':
      return translate('peerInsights.screen2.balances', 'Balances')
    case 'interestRate':
      return translate('peerInsights.screen2.interestRate', 'Interest Rate')
    case 'commission':
      return translate('peerInsights.screen2.commission', 'Commission')
    case 'npat':
      return translate('peerInsights.screen2.profit', 'NPAT')
    case 'marketShare':
      return translate('peerInsights.screen2.marketShare', 'Market Share')
    case 'customers':
      return translate('peerInsights.screen2.customers', 'Customers')
    case 'annualFee':
      return translate('peerInsights.screen2.annualFee', 'Annual Fee')
    case 'loyaltyPoints':
      return translate('peerInsights.screen2.loyaltyPoints', 'Loyalty Points')
    default:
      return startCase(camelCase(type))
  }
}
